import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Cred from "@/views/Cred.vue"
import Layout from '../layouts/Layout.vue'
import Dashboard from '../views/Dashboard.vue'
import AdminPanel from '../views/AdminPanel.vue'
import keycloak from '../keycloak'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: "/cred",
    name: "Cred",
    component: Cred
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'dashboard',
        component: Dashboard,
        beforeEnter: (to, from, next) => {
          if (keycloak.authenticated) next()
          else next('/')
        }
      },
      {
        path: 'admin-panel',
        component: AdminPanel,
        beforeEnter: (to, from, next) => {
          if (!keycloak.authenticated) {
            next('/')
            return
          }

          const roles = keycloak.tokenParsed?.realm_access?.roles || []

          if (roles.includes('admin')) {
            next()
          } else {
            next('/dashboard')
          }
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router